import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface LoadingFallbackProps {
  message?: string;
  className?: string;
  /** After this many ms, show a "taking longer" message and refresh prompt (default: 15000) */
  timeoutMs?: number;
}

const DEFAULT_LOADING_TIMEOUT_MS = 15_000;

export const LoadingFallback = ({ message, className = "", timeoutMs = DEFAULT_LOADING_TIMEOUT_MS }: LoadingFallbackProps) => {
  const { t } = useTranslation('common');
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (timeoutMs == null || timeoutMs <= 0) return;
    const id = setTimeout(() => setTimedOut(true), timeoutMs);
    return () => clearTimeout(id);
  }, [timeoutMs]);

  if (timedOut) {
    return (
      <div className={`flex flex-col items-center justify-center gap-3 p-6 ${className}`}>
        <p className="text-muted-foreground text-sm text-center">
          {t('loadingSlow', 'This is taking longer than usual.')}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="text-sm text-primary hover:underline"
        >
          {t('refreshPage', 'Refresh page')}
        </button>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center min-h-[12rem] ${className}`}>
      {message || t('common:loading')}
    </div>
  );
};